"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Kbd = exports.KbdKeys = void 0;
/*---------------------------------------------------------------------------------------------
 * Copyright (c) Bentley Systems, Incorporated. All rights reserved.
 * See LICENSE.md in the project root for license terms and full copyright notice.
 *--------------------------------------------------------------------------------------------*/
const classnames_1 = __importDefault(require("classnames"));
const React = __importStar(require("react"));
const index_js_1 = require("../../utils/index.js");
require("@itwin/itwinui-css/css/keyboard.css");
/**
 * Some predefined strings for common keyboard keys.
 */
exports.KbdKeys = {
    Command: '\u2318 Cmd',
    Shift: '\u21e7 Shift',
    Backspace: '\u232b Backspace',
    Enter: '\u21b5 Enter',
    Eject: '\u23cf Eject',
    Control: 'Ctrl',
    Windows: '\u229e Win',
    Apple: '\uf8ff',
    Option: '\u2325 Option',
    Left: '\u2190',
    Up: '\u2191',
    Right: '\u2192',
    Down: '\u2193',
};
/**
 * A keyboard key element.
 * @example
 * <Kbd>A</Kbd>
 * <Kbd title='Enter'>{KbdKeys.Enter}</Kbd>
 */
const Kbd = (props) => {
    const { className, children, ...rest } = props;
    (0, index_js_1.useTheme)();
    return (React.createElement("kbd", { className: (0, classnames_1.default)('iui-keyboard', className), ...rest }, children));
};
exports.Kbd = Kbd;
exports.default = exports.Kbd;
